import { Checkbox, Button, Popover, Tooltip, Image, Input, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import search_icon from "../../../../assets/search_icon.svg";
import searchWhite_icon from "../../../../assets/WhiteIcons/searchWhite_icon.svg";
import DefaultBrandLogo from "../../../../assets/brandLogos/Default_Brand.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setTemplateWidgetBrands,
  setTemplateWidgetFilter,
} from "../../../../redux/actions/section/section";
import { setTemplateFilter } from "../../../../redux/actions/section/section";
import {
  setDashboardBrandObj,
  setDashboardProfileFilterObj,
} from "../../../../redux/actions/Template";
import { getPaneIndex, getBrands } from "../../../../redux/constants";
import { setSectionLogicalBrandValue } from "../../../../redux/actions/LogicalGroup";
import {
  setSelectProfileFilterValue,
  setProfileFilterCheckedItems,
} from "../../../../redux/actions/ProfileFilter";
import { setIsWidgetEdit } from "../../../../redux/actions/Filter";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../../DeepDive/DeepDivetab/SocialMediaPlatforms";
import { LoadingOutlined } from "@ant-design/icons";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";

const ProfileFilter = ({ createWorkSpace, type, preview_metadata }) => {
  const [visible, setVisible] = useState(false);
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);

  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const [brandValue, setBrandValue] = useState(brands);
  const [search, setSearch] = useState("");

  // new states
  const selectProfileFilterValue = useSelector(
    (state) => state?.ProfileFilter?.selectProfileFilterValue
  );
  const profileFilterCheckedItems = useSelector(
    (state) => state?.ProfileFilter?.profileFilterCheckedItems
  );

  const panes = useSelector((state) => state?.Tab1?.panes);

  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const dispatch = useDispatch();
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const selectedSection = useSelector((state) => state.Section.filterObject);

  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const dashboardBrandObj = useSelector(
    (state) => state?.Template?.dashboardBrandObj
  ); //add in dashboard section and dashboard widget
  const templateDateFilterObj = useSelector(
    (state) => state?.Section?.templateFilterObj
  ); //add in template section and template widget
  const clearBrandAndDuration = useSelector(
    (state) => state?.Template?.clearBrandAndDuration
  ); //contains information about clear filter
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  let index = getPaneIndex(panes, activeKey);
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  // console.log("profile Filter.js", profileFilterList);

  const profileFilterLoader = useSelector(
    (state) => state?.apiCall?.profile_filter_loader
  );

  const suffix = (
    <img
      src={authParams?.theme_type === "1" ? searchWhite_icon : search_icon}
      alt="search icon"
      style={{ maxWidth: "2.5rem" }}
    />
  );
  const brandTitleContainer = useRef(null);
  const [brandLogicalGroupValue, setBrandLogicalGroupValue] =
    useState(brandlogicalgroup);
  const [competitorBrandsValue, setcompetitorBrandsValue] =
    useState(competitorBrands);
  const [brandLogicalGroupCollapse, setBrandLogicalGroupCollapse] =
    useState(true);

  const widgetMakerBrands = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig?.brands
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const widgetPreview = useSelector((state) => state.WidgetAPI.widgetPreview);
  let widget_metadata =
    type === "preview"
      ? widgetPreview?.metadata
      : editPanelInfo?.type === "dashboard_widget"
      ? panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
            editPanelInfo?.widget_index
          ]
        : panes[index]?.section?.[0].widgets?.[editPanelInfo?.widget_index]
      : editPanelInfo?.type === "template_widget" &&
        Section?.[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ];

  let section_metadata =
    type === "preview"
      ? widgetPreview?.metadata
      : editPanelInfo?.type === "dashboard_widget"
      ? panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]
        : panes[index]?.section?.[0]
      : editPanelInfo?.type === "template_widget" &&
        Section?.[editPanelInfo?.section_index];

  let sectionBrand =
    editPanelInfo?.type === "dashboard_widget"
      ? section_metadata?.brand_ids || section_metadata?.brand_groups
      : editPanelInfo?.type === "template_widget" && section_metadata?.brands;

  let widgetBrand =
    editPanelInfo?.type === "dashboard_widget"
      ? (dashboardBrandObj && dashboardBrandObj?.brandFilters) ||
        widget_metadata?.is_locked
      : editPanelInfo?.type === "template_widget" && widget_metadata?.is_locked;

  const [widgetProfileList, setWidgetProfileList] = useState(
    widget_metadata?.profile_filters_list
  );
  const [sectionProfileList, setSectionProfileList] = useState(
    section_metadata?.profile_filters_list
  );
  const [profileFilterValue, setProfileFilterValue] =
    useState(profileFilterList);

  //setting default value to All checked
  useEffect(() => {
    !profileFilterValue && setProfileFilterValue(profileFilterList);
    setWidgetProfileList(widget_metadata?.profile_filters_list);
    setSectionProfileList(section_metadata?.profile_filters_list);
    resetState();
  }, [
    type,
    widgetGraphConfig?.widgetResetState,
    templateDetails,
    panes,
    widgetMakerBrands,
    profileFilterList,
    dashboardBrandObj,
    profileFilterLoader,
  ]);

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);

  const handleSelectProfileFilter = (e, value, type1, item) => {
    let a = {
      name: value?.id ? value?.id : null,
      type: "include",
      display_name: value?.name ? value?.name : null,
      profile_channel: value?.channel ? value?.channel : null,
      brand_id: value?.brand_id ? value?.brand_id : null,
    };

    let updatecheckedValue = { ...profileFilterCheckedItems };
    let updateselectValue = { ...selectProfileFilterValue };

    let arr = selectProfileFilterValue[type]?.data?.columns
      ? selectProfileFilterValue[type]?.data?.columns
      : []; //for template brands

    let myArr = arr?.filter((item) => {
      return item.name !== a.name && item.name !== "" && item !== null;
    });

    if (e?.target?.checked === true) {
      myArr.push(a);

      updatecheckedValue[type].data[
        type1 === "group" ? e.target.value + "_group" : e.target.value
      ] = e.target.checked;

      dispatch(setProfileFilterCheckedItems(updatecheckedValue));
    } else if (e?.target?.checked === false) {
      myArr?.filter((item) => {
        return item?.name !== a?.name && item !== "" && item !== null;
      });
      updatecheckedValue[type].data[
        type1 === "group" ? e.target.value + "_group" : e.target.value
      ] = e.target.checked;

      dispatch(setProfileFilterCheckedItems(updatecheckedValue));
    }

    updateselectValue[type].data = {
      columns: myArr,
      attribute: "SocialMediaProfiles",
      type: "varchar",
    };
    dispatch(setSelectProfileFilterValue(updateselectValue));
  };

  const resetState = () => {
    let index = getPaneIndex(panes, activeKey);
    if (type === "dashboard_widget") {
      let section_metadata = panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]
        : panes?.[index]?.section?.[0];

      let widget_metadata = panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
            editPanelInfo?.widget_index
          ]
        : panes?.[index]?.section?.[0]?.widgets?.[editPanelInfo?.widget_index];

      let section_profile_list = section_metadata?.profile_filters_list
        ? section_metadata?.profile_filters_list?.length === 0
        : !section_metadata?.profile_filters_list;

      if (widget_metadata?.profile_filters) {
        dispatch(
          setDashboardProfileFilterObj(widget_metadata?.profile_filters)
        );
      } else {
        dispatch(setDashboardProfileFilterObj(null));
      }

      // console.log(
      //   "dashboardBrandObj",
      //   dashboardBrandObj?.brandFilters,
      //   "section_metadata",
      //   section_metadata,
      //   "widget_metadata",
      //   widget_metadata,
      //   "section_profile_list",
      //   section_profile_list
      // );

      let updateselectValue = { ...selectProfileFilterValue };
      if (
        section_metadata?.profile_filters_list?.length > 0 &&
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        !widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters
      ) {
        let columns = [
          {
            name: section_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: section_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              section_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: section_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        profileFilterList?.length &&
        !widget_metadata?.profile_filters &&
        !widget_metadata?.is_locked
      ) {
        let columns = [
          {
            name: profileFilterValue?.[0]?.id,
            group: false,
            type: "include",
            display_name: profileFilterValue?.[0]?.name,
            profile_channel: profileFilterValue?.[0]?.channel,
            brand_id: profileFilterValue?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        widget_metadata?.is_locked &&
        section_profile_list
      ) {
        let columns = [
          {
            name: profileFilterValue?.[0]?.id,
            group: false,
            type: "include",
            display_name: profileFilterValue?.[0]?.name,
            profile_channel: profileFilterValue?.[0]?.channel,
            brand_id: profileFilterValue?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (widget_metadata?.profile_filters?.columns?.length) {
        updateselectValue[type].data = {
          columns: widget_metadata?.profile_filters?.columns?.length
            ? widget_metadata?.profile_filters?.columns
            : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list
      ) {
        let columns = [
          {
            name: widget_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: widget_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              widget_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        section_metadata?.profile_filters_list?.length &&
        !widget_metadata?.profile_filters_list
      ) {
        let columns = [
          {
            name: section_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: section_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              section_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: section_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        let updateselectValue = { ...selectProfileFilterValue };
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else {
        if (
          profileFilterList?.length === 0 ||
          widget_metadata?.profile_filters_list?.length === 0
        ) {
          let updateselectValue = { ...selectProfileFilterValue };
          updateselectValue[type].data = {
            columns: [],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
          dispatch(setSelectProfileFilterValue(updateselectValue));
        } else {
          dispatch(setSelectProfileFilterValue(updateselectValue));
        }
      }

      let updatecheckedValue = { ...profileFilterCheckedItems };
      if (
        section_metadata?.profile_filters_list?.length > 0 &&
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        !widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[
          section_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        profileFilterList?.length &&
        !widget_metadata?.profile_filters &&
        !widget_metadata?.is_locked
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[profileFilterList?.[0]?.id] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        widget_metadata?.is_locked &&
        section_profile_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[profileFilterValue?.[0]?.id] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (widget_metadata?.profile_filters?.columns?.length) {
        updatecheckedValue[type].data = {};
        widget_metadata?.profile_filters?.columns?.map((d, i) => {
          updatecheckedValue[type].data[d?.name] = true;
        });
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[
          widget_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        section_metadata?.profile_filters_list?.length &&
        !widget_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[
          section_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else {
        if (
          profileFilterList?.length === 0 ||
          widget_metadata?.profile_filters_list?.length === 0
        ) {
          let updatecheckedValue = { ...profileFilterCheckedItems };
          updatecheckedValue[type].data = {};
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        } else {
          updatecheckedValue[type].data[
            widget_metadata?.profile_filters?.columns?.[0]?.name
              ? widget_metadata?.profile_filters?.columns?.[0]?.name
              : "All"
          ] = true;
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        }
      }
    }
    if (type === "template_widget") {
      let widget_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]
          : Section?.[0]?.data?.[editPanelInfo?.widget_index];

      let section_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]
          : Section?.[0];

      // console.log("edit case",
      // section_metadata,
      // widget_metadata,
      // selectProfileFilterValue[type]?.data,
      // )

      let section_profile_list = section_metadata?.profile_filters_list
        ? section_metadata?.profile_filters_list?.length === 0
        : !section_metadata?.profile_filters_list;

      let updateselectValue = { ...selectProfileFilterValue };
      if (
        window.location.pathname === "/create-dashboard" &&
        widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters_list &&
        section_profile_list
      ) {
        let columns = [
          {
            name: profileFilterValue?.[0]?.id,
            group: false,
            type: "include",
            display_name: profileFilterValue?.[0]?.name,
            profile_channel: profileFilterValue?.[0]?.channel,
            brand_id: profileFilterValue?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters &&
        section_metadata?.profile_filters_list
      ) {
        let columns = [
          {
            name: section_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: section_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              section_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: section_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters_list
      ) {
        let columns = [
          {
            name: widget_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: widget_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              widget_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters
      ) {
        let columns = [
          {
            name: profileFilterValue?.[0]?.id,
            group: false,
            type: "include",
            display_name: profileFilterValue?.[0]?.name,
            profile_channel: profileFilterValue?.[0]?.channel,
            brand_id: profileFilterValue?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      }
      // edit case
      else if (
        widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        widget_metadata?.is_locked &&
        section_profile_list
      ) {
        let columns = [
          {
            name: profileFilterValue?.[0]?.id,
            group: false,
            type: "include",
            display_name: profileFilterValue?.[0]?.name,
            profile_channel: profileFilterValue?.[0]?.channel,
            brand_id: profileFilterValue?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (widget_metadata?.profile_filters?.columns?.length) {
        updateselectValue[type].data = {
          columns: widget_metadata?.profile_filters?.columns?.length
            ? widget_metadata?.profile_filters?.columns
            : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length > 0
      ) {
        let columns = [
          {
            name: widget_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: widget_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              widget_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        section_metadata?.profile_filters_list?.length &&
        !widget_metadata?.profile_filters_list
      ) {
        let columns = [
          {
            name: section_metadata?.profile_filters_list?.[0]?.id,
            group: false,
            type: "include",
            display_name: section_metadata?.profile_filters_list?.[0]?.name,
            profile_channel:
              section_metadata?.profile_filters_list?.[0]?.channel,
            brand_id: section_metadata?.profile_filters_list?.[0]?.brand_id,
          },
        ];
        updateselectValue[type].data = {
          columns: columns ? columns : [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else if (
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters?.columns?.length &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        let updateselectValue = { ...selectProfileFilterValue };
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));
      } else {
        if (
          profileFilterList?.length === 0 ||
          widget_metadata?.profile_filters_list?.length === 0
        ) {
          let updateselectValue = { ...selectProfileFilterValue };
          updateselectValue[type].data = {
            columns: [],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
          dispatch(setSelectProfileFilterValue(updateselectValue));
        } else {
          dispatch(setSelectProfileFilterValue(updateselectValue));
        }
      }

      // console.log("edit case ",
      // section_metadata,
      // widget_metadata,
      // profileFilterCheckedItems[type]?.data)

      let updatecheckedValue = { ...profileFilterCheckedItems };
      if (
        window.location.pathname === "/create-dashboard" &&
        widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updatecheckedValue[type].data = {};
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters_list &&
        section_profile_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[profileFilterValue?.[0]?.id] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters &&
        section_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[
          section_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[
          widget_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        !widget_metadata?.profile_filters
      ) {
        updatecheckedValue[type].data = {};
        updatecheckedValue[type].data[profileFilterValue?.[0]?.id] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        window.location.pathname === "/create-dashboard" &&
        widget_metadata?.is_locked &&
        widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updatecheckedValue[type].data = {};
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      }
      // edit case
      else if (
        widget_metadata?.is_locked &&
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list?.length === 0
      ) {
        updatecheckedValue[type].data = {};
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        dashboardBrandObj &&
        !dashboardBrandObj?.brandFilters &&
        widget_metadata?.is_locked &&
        section_profile_list
      ) {
        updatecheckedValue[type].data[profileFilterValue?.[0]?.id] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (widget_metadata?.profile_filters?.columns?.length) {
        updatecheckedValue[type].data = {};
        widget_metadata?.profile_filters?.columns?.map((d, i) => {
          updatecheckedValue[type].data[d?.name] = true;
        });
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        !widget_metadata?.profile_filters &&
        widget_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data[
          widget_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else if (
        section_metadata?.profile_filters_list?.length &&
        !widget_metadata?.profile_filters_list
      ) {
        updatecheckedValue[type].data[
          section_metadata?.profile_filters_list?.[0]?.id
        ] = true;
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      } else {
        if (
          profileFilterList?.length === 0 ||
          widget_metadata?.profile_filters_list?.length === 0
        ) {
          let updatecheckedValue = { ...profileFilterCheckedItems };
          updatecheckedValue[type].data = {};
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        } else {
          updatecheckedValue[type].data[
            widget_metadata?.profile_filters?.columns?.[0]?.name
              ? widget_metadata?.profile_filters?.columns?.[0]?.name
              : "All"
          ] = true;
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        }
      }
    }
  };
  // console.log(
  //   "final selectProfileFilterValue",
  //   { ...selectProfileFilterValue?.[type]?.data },
  //   "final profileFilterCheckedItems",
  //   { ...profileFilterCheckedItems?.[type]?.data }
  // );

  //function to open and close dropdown
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
    setSearch();
    setBrandValue(brands);
    setBrandLogicalGroupValue(brandlogicalgroup);
    setcompetitorBrandsValue(competitorBrands);
  };

  const controlNavbar = () => {
    if (window.scrollY > 0) {
      handleVisibleChange(false);
    }
  };

  const handleDone = (value) => {
    if (
      type === "dashboard_widget" &&
      editPanelInfo &&
      selectProfileFilterValue[type]?.data?.columns?.length
    ) {
      let obj = selectProfileFilterValue?.[type]?.data;
      dispatch(setDashboardProfileFilterObj(obj));
    }

    if (
      type === "template_widget" &&
      selectProfileFilterValue[type]?.data?.columns?.length
    ) {
      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        widget_index: editPanelInfo?.widget_index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        // selectBrands: selectProfileFilterValue[type]?.data,
      };

      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;

      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let widget_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.profile_filters_list
          : Section?.[0]?.data?.[editPanelInfo?.widget_index]
              ?.profile_filters_list;

      let section_profile_filters_list =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.profile_filters_list
          : Section?.[0]?.profile_filters_list;

      let profile_filters = selectProfileFilterValue[type]?.data;

      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        widget_index: selectedSection?.widget_index,
        authParams: authParams,
        global_brands: selectedSection?.is_locked
          ? templateObj1?.selectBrands
            ? templateObj1?.selectBrands
            : selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.brandFilters
            : Section[0]?.data[selectedSection?.widget_index]?.brandFilters
          : global_brands,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        filters: value
          ? value
          : selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.onlyFilters
          : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
        duration: selectedSection?.is_locked
          ? templateDateFilterObj?.templateObj?.durationObj
            ? templateDateFilterObj?.templateObj?.durationObj
            : Section[selectedSection?.section_index]?.dateFilters
            ? Section[selectedSection?.section_index]?.dateFilters
            : global_duration
          : global_duration,
        is_locked: selectedSection?.is_locked,
        brandFilters: templateObj1?.selectBrands
          ? templateObj1?.selectBrands
          : selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.brandFilters
          : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
        dateFilters:
          // templateDateFilterObj?.templateObj?.durationObj
          //   ? templateDateFilterObj?.templateObj?.durationObj
          //   :
          selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.dateFilters
            : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
        clear: false,
        span_check:
          templateDateFilterObj?.templateObj?.durationObj ||
          templateObj1?.selectBrands ||
          value?.length > 0
            ? true
            : false,
        profile_filters: profile_filters ? profile_filters : null,
        profile_filters_list:
          widget_metadata?.is_locked && widget_profile_filters_list
            ? widget_profile_filters_list
            : section_profile_filters_list?.length
            ? section_profile_filters_list
            : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(setTemplateWidgetFilter(templateObj, false));

      let obj = {
        type: "template_widget",
        filters: global,
        section: templateObj1?.section ? templateObj1?.section : Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        currentFilter: value ? value : [],
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setTemplateFilter(obj, templateObj));
    }
    setVisible(value);
  };

  const handleClear = (value) => {
    if (type === "dashboard_widget" && editPanelInfo) {
      let updatecheckedValue = { ...profileFilterCheckedItems };
      let updateselectValue = { ...selectProfileFilterValue };
      updatecheckedValue[type].data = {}; //to clear all data
      dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "SocialMediaProfiles",
        type: "varchar",
      };
      dispatch(setSelectProfileFilterValue(updateselectValue));

      dispatch(setDashboardProfileFilterObj(null));
    }
    if (type === "template_widget") {
      let updatecheckedValue = { ...profileFilterCheckedItems };
      let updateselectValue = { ...selectProfileFilterValue };
      updatecheckedValue[type].data = {};
      dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      updateselectValue[type].data = {
        columns: [],
        attribute: "SocialMediaProfiles",
        type: "varchar",
      };
      dispatch(setSelectProfileFilterValue(updateselectValue));
    }
    setVisible(value);
  };

  const handleCancel = (value) => {
    setVisible(value);
    setSearch();
    setProfileFilterValue(profileFilterList);
    setWidgetProfileList(widget_metadata?.profile_filters_list);
    setSectionProfileList(section_metadata?.profile_filters_list);
  };

  const handleSearch = (e) => {
    if (String(e.target.value).trim() !== "") {
      let profileFilters = [];
      // console.log("widget",
      // widgetProfileList,widget_metadata?.profile_filters_list,
      // "Section",
      // sectionProfileList,section_metadata?.profile_filters_list,
      // "Global",
      // profileFilterValue);

      // console.log("check",
      // widget_metadata,
      // sectionBrand,
      // widgetBrand,
      // )

      if (widgetProfileList && widgetBrand) {
        widget_metadata?.profile_filters_list?.forEach((el) => {
          if (
            String(el?.name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            profileFilters = [...profileFilters, { ...el }];
          }
        });
        setWidgetProfileList(profileFilters);
        setSearch(e?.target?.value);
      } else if (sectionProfileList?.length && sectionBrand) {
        section_metadata?.profile_filters_list?.forEach((el) => {
          if (
            String(el?.name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            profileFilters = [...profileFilters, { ...el }];
          }
        });
        setSectionProfileList(profileFilters);
        setSearch(e?.target?.value);
      } else if (profileFilterValue && !widget_metadata?.is_locked) {
        profileFilterList?.forEach((el) => {
          if (
            String(el?.name)
              ?.trim()
              ?.toLowerCase()
              ?.includes(String(e?.target?.value)?.trim()?.toLowerCase())
          ) {
            profileFilters = [...profileFilters, { ...el }];
          }
        });
        setProfileFilterValue(profileFilters);
        setSearch(e?.target?.value);
      }
    } else {
      if (widget_metadata?.profile_filters_list && widgetBrand) {
        setWidgetProfileList(widget_metadata?.profile_filters_list);
      }
      if (section_metadata?.profile_filters_list && sectionBrand) {
        setSectionProfileList(section_metadata?.profile_filters_list);
      }
      if (profileFilterValue && !widget_metadata?.is_locked) {
        setProfileFilterValue(profileFilterList);
      }
      setSearch(e?.target?.value);
    }
  };

  return (
    <Popover
      content={
        <>
          <div
            className="custom_scroll p-15"
            style={{
              maxHeight: type === "share_modal" ? "18rem" : "22rem",
              overflow: "auto",
              minWidth: "25rem",
              width: brandTitleContainer?.current?.clientWidth
                ? brandTitleContainer?.current?.clientWidth
                : type === "share_modal"
                ? "55rem"
                : "25rem",
              maxWidth: brandTitleContainer?.current?.clientWidth
                ? brandTitleContainer?.current?.clientWidth
                : type === "dashboard_section" ||
                  type === "dashboard_widget" ||
                  type === "template_section" ||
                  type === "template_widget"
                ? "25rem"
                : type === "share_modal"
                ? "55rem"
                : "25rem",
            }}
          >
            <Input
              className="border-radius-4 border-color mb-3"
              placeholder="Search Profiles"
              suffix={suffix}
              style={{ height: "3.5rem" }}
              value={search}
              allowClear={true}
              onChange={(e) => handleSearch(e)}
            />
            {type === "dashboard_widget" || type === "template_widget"
              ? true
              : true && (
                  <div
                    className={`portlet-label  mb-1 d-flex  align-items-center justify-content-between `}
                  >
                    <span className="font-weight500">Profiles</span>
                    <span
                      className="cursor-pointer text-center"
                      style={{
                        width: "2.2rem",
                        height: "100%",
                        verticalAlign: "middle",
                      }}
                      onClick={() =>
                        setBrandLogicalGroupCollapse(!brandLogicalGroupCollapse)
                      }
                    >
                      <img
                        src={
                          authParams?.theme_type === "1"
                            ? accoArrowWhite
                            : accoArrow
                        }
                        alt="arrow"
                        className="accordionArrow"
                        style={{
                          transform: `rotate(${
                            brandLogicalGroupCollapse ? "0deg" : "180deg"
                          })`,
                          maxWidth: "100%",
                        }}
                      />
                    </span>
                  </div>
                )}

            {/* {console.log(
            "widgetProfileList",widgetProfileList,
            "sectionProfileList",sectionProfileList,
            "profileFilterValue",profileFilterValue
            )} */}

            {/* Profile Filters */}
            {(window.location.pathname === "/dashboard" ||
            window.location.pathname === "/pin-dashboard"
              ? dashboardBrandObj?.brandFilters
              : !dashboardBrandObj?.brandFilters) &&
            (widget_metadata?.is_locked || selectedSection?.is_locked) &&
            widget_metadata?.profile_filters_flag &&
            (dashboardBrandObj?.brandFilters ||
              widget_metadata?.brand_ids ||
              widget_metadata?.brand_groups) &&
            widgetProfileList
              ? widgetProfileList?.length > 0
                ? widgetProfileList?.map((el, i) => {
                    return (
                      <div className="text_regular mb-1" key={`brand_list${i}`}>
                        <Checkbox
                          onChange={(item) =>
                            handleSelectProfileFilter(item, el)
                          }
                          value={el?.id}
                          checked={
                            profileFilterCheckedItems[type]?.data &&
                            profileFilterCheckedItems[type]?.data[el?.id]
                          }
                          style={{
                            display: "inline-flex",
                            lineHeight: "normal",
                            alignItems: "center",
                          }}
                        >
                          <span className="d-flex align-items-center">
                            <Image
                              style={{
                                width: "2rem",
                                maxHeight: "2rem",
                                borderRadius: "50%",
                                marginRight: "1rem",
                              }}
                              src={SocialMedialogo?.[el?.channel]}
                              fallback={DefaultBrandLogo}
                              preview={false}
                            />
                            <Image
                              style={{
                                width: "2rem",
                                maxHeight: "2rem",
                                borderRadius: "50%",
                                marginRight: "1rem",
                              }}
                              src={el?.profile_icon_url}
                              fallback={DefaultBrandLogo}
                              preview={false}
                            />
                            {el?.name}
                          </span>
                        </Checkbox>
                      </div>
                    );
                  })
                : "No Profile List"
              : sectionProfileList?.length > 0
              ? sectionProfileList?.length > 0
                ? sectionProfileList?.map((el, i) => {
                    return (
                      <div className="text_regular mb-1" key={`brand_list${i}`}>
                        <Checkbox
                          onChange={(item) =>
                            handleSelectProfileFilter(item, el)
                          }
                          value={el?.id}
                          checked={
                            profileFilterCheckedItems[type]?.data &&
                            profileFilterCheckedItems[type]?.data[el?.id]
                          }
                          style={{
                            display: "inline-flex",
                            lineHeight: "normal",
                            alignItems: "center",
                          }}
                        >
                          <span className="d-flex align-items-center">
                            <Image
                              style={{
                                width: "2rem",
                                maxHeight: "2rem",
                                borderRadius: "50%",
                                marginRight: "1rem",
                              }}
                              src={SocialMedialogo?.[el?.channel]}
                              fallback={DefaultBrandLogo}
                              preview={false}
                            />
                            <Image
                              style={{
                                width: "2rem",
                                maxHeight: "2rem",
                                borderRadius: "50%",
                                marginRight: "1rem",
                              }}
                              src={el?.profile_icon_url}
                              fallback={DefaultBrandLogo}
                              preview={false}
                            />
                            {el?.name}
                          </span>
                        </Checkbox>
                      </div>
                    );
                  })
                : "No Profile List"
              : profileFilterValue && profileFilterValue?.length > 0
              ? profileFilterValue?.map((el, i) => {
                  return (
                    <div className="text_regular mb-1" key={`brand_list${i}`}>
                      <Checkbox
                        onChange={(item) => handleSelectProfileFilter(item, el)}
                        value={el?.id}
                        checked={
                          profileFilterCheckedItems[type]?.data &&
                          profileFilterCheckedItems[type]?.data[el?.id]
                        }
                        style={{
                          display: "inline-flex",
                          lineHeight: "normal",
                          alignItems: "center",
                        }}
                      >
                        <span className="d-flex align-items-center">
                          <Image
                            style={{
                              width: "2rem",
                              maxHeight: "2rem",
                              borderRadius: "50%",
                              marginRight: "1rem",
                            }}
                            src={SocialMedialogo?.[el?.channel]}
                            fallback={DefaultBrandLogo}
                            preview={false}
                          />
                          <Image
                            style={{
                              width: "2rem",
                              maxHeight: "2rem",
                              borderRadius: "50%",
                              marginRight: "1rem",
                            }}
                            src={el?.profile_icon_url}
                            fallback={DefaultBrandLogo}
                            preview={false}
                          />
                          {el?.name}
                        </span>
                      </Checkbox>
                    </div>
                  );
                })
              : "No Profile List"}
          </div>

          <div
            className="footer w-100 bg__white d-flex justify-content-between border-top"
            style={{ padding: "0.8rem 1.5rem" }}
          >
            <>
              <Button onClick={() => handleClear(false)} className="btn_Clear">
                Clear
              </Button>
              <div className="d-flex justify-content-between">
                <Button
                  onClick={() => handleCancel(false)}
                  className="btn_Clear mr-15"
                >
                  Cancel
                </Button>
                <Tooltip
                  title={
                    selectProfileFilterValue?.[type]?.data?.columns?.length > 5
                      ? "More than 5 profiles can not be selected."
                      : selectProfileFilterValue?.[type]?.data?.columns
                          ?.length === 0
                      ? "Select atleast 1 profile to get data in widget."
                      : ""
                  }
                >
                  <Button
                    disabled={
                      selectProfileFilterValue?.[type]?.data?.columns?.length >
                      5
                        ? true
                        : selectProfileFilterValue?.[type]?.data?.columns
                            ?.length === 0
                        ? true
                        : false
                    }
                    style={{ color: "#fff" }}
                    onClick={() => handleDone(false)}
                    type="primary"
                    className={`ant-btn-primary_blue`}
                  >
                    Done
                  </Button>
                </Tooltip>
              </div>
            </>
          </div>
        </>
      }
      title={null}
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="bottomLeft"
      overlayClassName={
        authParams?.theme_type === "1"
          ? "darkTheme brandsdropdown"
          : "lightTheme brandsdropdown"
      }
    >
      <div
        style={{
          padding: "0.8rem 1.2rem",
          borderRadius: "0.4rem",
          minWidth: "18rem",
        }}
        className={`border-color border text_regular cursor-pointer d-flex align-items-center justify-content-between ${
          (graphLoader || aggregateLoader || profileLoader) && "disable"
        }`}
        onClick={(e) => e.preventDefault()}
        ref={brandTitleContainer}
      >
        <div className="d-flex align-items-center">
          {type === "dashboard_widget" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {/* {console.log("selectProfileFilterValue[type]?.data",
                selectProfileFilterValue[type]?.data)} */}

                {profileFilterLoader ? (
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ fontSize: 20 }} spin />
                    }
                  />
                ) : widget_metadata?.type === "predefined" ? (
                  !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length ===
                    0 ? (
                    "No Profile"
                  ) : selectProfileFilterValue[type]?.data?.columns?.length >
                      0 &&
                    !selectProfileFilterValue[type]?.data?.columns[0]
                      ?.brand_group_name &&
                    !selectProfileFilterValue[type]?.data?.columns[0]
                      ?.competitor ? (
                    selectProfileFilterValue[type]?.data?.columns[0]
                      ?.display_name ? (
                      selectProfileFilterValue[type]?.data?.columns[0]
                        ?.display_name
                    ) : (
                      "No Profile"
                    )
                  ) : (
                    "No Profile"
                  )
                ) : !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length ===
                    0 ? (
                  "No Profile"
                ) : profileFilterCheckedItems[type]?.data.All ? (
                  "All"
                ) : (
                  selectProfileFilterValue[type]?.data?.columns[0]?.display_name
                )}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length <= 1
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectProfileFilterValue[type]?.data
                  ? selectProfileFilterValue[type]?.data &&
                    selectProfileFilterValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : type === "template_widget" ? (
            <>
              <div
                className="mr-1 text_regular text-ellipsis"
                // style={{ maxWidth: "9.8rem" }}
              >
                {profileFilterLoader ? (
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ fontSize: 20 }} spin />
                    }
                  />
                ) : widget_metadata?.type === "predefined" ? (
                  !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length ===
                    0 ? (
                    "No Profile"
                  ) : selectProfileFilterValue[type]?.data?.columns?.length >
                      0 &&
                    !selectProfileFilterValue[type]?.data?.columns[0]
                      ?.brand_group_name &&
                    !selectProfileFilterValue[type]?.data?.columns[0]
                      ?.competitor ? (
                    selectProfileFilterValue[type]?.data?.columns[0]
                      ?.display_name ? (
                      selectProfileFilterValue[type]?.data?.columns[0]
                        ?.display_name
                    ) : (
                      "No Profile"
                    )
                  ) : (
                    "No Profile"
                  )
                ) : !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length ===
                    0 ? (
                  "No Profile"
                ) : profileFilterCheckedItems[type]?.data?.All ? (
                  "All"
                ) : (
                  selectProfileFilterValue[type]?.data?.columns?.length > 0 &&
                  selectProfileFilterValue[type]?.data?.columns[0]?.display_name
                )}
              </div>

              <div
                className={`text_regular ml-1 mr-1 ${
                  !selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length <= 1
                    ? "d-none"
                    : ""
                }`}
              >
                +
                {selectProfileFilterValue[type]?.data
                  ? selectProfileFilterValue[type]?.data &&
                    selectProfileFilterValue[type]?.data?.columns?.length - 1
                  : "(0)"}
              </div>
            </>
          ) : (
            type === "share_modal" && (
              <>
                <div
                  className="mr-1 text_regular text-ellipsis"
                  // style={{ maxWidth: "9.8rem" }}
                >
                  {!selectProfileFilterValue[type]?.data ||
                  selectProfileFilterValue[type]?.data?.columns?.length === 0
                    ? "No Brand"
                    : profileFilterCheckedItems[type]?.data.All
                    ? "All"
                    : selectProfileFilterValue[type]?.data?.columns?.length >
                        0 &&
                      selectProfileFilterValue[type]?.data?.columns[0]
                        ?.brand_friendly_name}
                </div>

                <div
                  className={`text_regular mr-1 ${
                    !selectProfileFilterValue[type]?.data ||
                    (selectProfileFilterValue[type]?.data?.columns &&
                      !selectProfileFilterValue[type]?.data?.columns[0]
                        ?.competitorList &&
                      selectProfileFilterValue[type]?.data?.columns?.length <=
                        1) ||
                    profileFilterCheckedItems[type]?.data.All
                      ? "d-none"
                      : ""
                  }`}
                >
                  +
                  {selectProfileFilterValue[type]?.data
                    ? selectProfileFilterValue[type]?.data &&
                      (selectProfileFilterValue[type]?.data?.columns[0]
                        ?.competitorList
                        ? selectProfileFilterValue[type]?.data?.columns[0]
                            ?.competitorList?.length
                        : selectProfileFilterValue[type]?.data?.columns
                            ?.length - 1)
                    : "(0)"}
                </div>
              </>
            )
          )}
        </div>
        <img
          src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
          className="accordionArrow p-0"
          alt="arrow"
        />
      </div>
    </Popover>
  );
};

export default React.memo(ProfileFilter, isEqual);
